import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'aggregator-settings-page',
  template: '<router-outlet></router-outlet>',
  standalone: true,
  imports: [RouterModule],
})
export class SettingsPage {}
